import { render, staticRenderFns } from "./ScalesListPage.vue?vue&type=template&id=139dffeb&scoped=true&"
import script from "./ScalesListPage.vue?vue&type=script&lang=js&"
export * from "./ScalesListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139dffeb",
  null
  
)

export default component.exports